/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAddonShow } from '../../axios/campaignAddonShow'
import type {
	CampaignAddonShowError,
	CampaignAddonShowPathParams,
	CampaignAddonShowResponse,
} from '../../types/CampaignAddonShow'

export const campaignAddonShowQueryKey = (campaign: CampaignAddonShowPathParams['campaign']) =>
	[{ url: '/campaigns/:campaign/addons', params: { campaign } }] as const

export type CampaignAddonShowQueryKey = ReturnType<typeof campaignAddonShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::show */
export function campaignAddonShowQueryOptions(
	campaign: CampaignAddonShowPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignAddonShowResponse,
		AxiosError<CampaignAddonShowError>,
		CampaignAddonShowResponse,
		CampaignAddonShowQueryKey
	>({
		queryKey: campaignAddonShowQueryKey(campaign),
		queryFn: ({ signal }) => campaignAddonShow(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::show */
export function useCampaignAddonShow<TSelectData = CampaignAddonShowResponse>(
	campaign: CampaignAddonShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignAddonShowResponse,
					AxiosError<CampaignAddonShowError>,
					TSelectData,
					CampaignAddonShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignAddonShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignAddonShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAddonController.php CampaignAddonController::show */
export function useCampaignAddonShowSuspense<TSelectData = CampaignAddonShowResponse>(
	campaign: CampaignAddonShowPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignAddonShowResponse,
					AxiosError<CampaignAddonShowError>,
					TSelectData,
					CampaignAddonShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignAddonShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignAddonShowQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
